import React, { useEffect } from "react";
import { FormGroup, FormText, Label } from "reactstrap";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";
import { FeedbackBugReportTypePicker } from "../../../Tags";

type Props = {
  selectedTypeId?: number;
  onChangeType: (selectedTypeId: number) => void;
};

const FeedbackFormBugReportTypeInput: React.FC<Props> = props => {
  return (
    <FormGroup>
      <Label for="tags">
        <ElementSpacer spacing=".25rem">Type of Bug</ElementSpacer>
      </Label>
      <FeedbackBugReportTypePicker
        selectedId={props.selectedTypeId}
        onSelectedTypeChange={props.onChangeType}
      />
    </FormGroup>
  );
};

export default FeedbackFormBugReportTypeInput;
